import { useEffect, useState } from "react";
import JobZImage from "../../../common/jobz-img";
import JobViewPopup from "../../../common/popups/popup-job-view";
import { loadScript } from "../../../../globals/constants";
import { useDispatch, useSelector } from "react-redux";
import apiCall from "../../../../apicall";
import SectionRecordsFilter from "../../public-user/sections/common/section-records-filter";
import TableLoader from "../../../common/tableLoader";
import moment from "moment";
import SectionPagination from "../../public-user/sections/common/section-pagination";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Spinner from "../../../common/spinner";
import Toast from "../../../common/toast";
import { jobDetailsData, employerDetails } from "../../../../store/reducers/menu";
import { Helmet } from "react-helmet-async";
import { formatCompanyName } from "../../../../globals/fomat-comapny-name";
import { logEvent_Analytics } from "../../../common/firebase/firebase-analytics-service";

function CanPaymentDetailsPage({ 
    customerDetail, 
    activeTab,
    isDownloadPaymentCSV,
    isDownloadJobCSV,
    empPaymentInfo,
    setEmpPaymentInfo,
    setIsDownloadJobCSV,
    setIsDownloadPaymentCSV,
    handleDownloadPaymentCSV,
    handleDownloadJobCSV
  }) {
  const { role_type, TOKEN, userInfo } = useSelector((state) => state.menu);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const currentUrl = location.pathname;
  const [paymentCurrentPage, setPaymentCurrentPage] = useState(1);
  const [rowPaymentPerPage, setPaymentRowPerPage] = useState(10);
  let customerId = "";
  const [paginationPaymentData, setPaginationPaymentData] = useState({
    totalElements: 0,
    totalPages: 0,
  });
  const [paymentLoader, setPaymentLoader] = useState(false);
  // const [sessionExpired, setSessionExpired] = useState(false);
  const [searchKey, setSearchKey] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [errSuccessMesg, setErrSuccessMsg] = useState({
    message: "",
    status: "error",
  });
  const [loadingButton, setLoadingButton] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [tableFilter, setTableFilter] = useState({
    sortType: "createdDate",
    sortDirection: "desc",
    jobStatus: "",
    searchKey: "",
    categoryType: "",
    dateFilter:"",
    startDate: "",
    endDate: "",
    companyName: ""
  });
  // const [empPaymentInfo, setEmpPaymentInfo] = useState({});

  const _filterConfig = {
    prefix: "Showing",
    type: "results",
    isSorting: false,
    total: paginationPaymentData?.totalElements,
    showRange: false,
    showingUpto: "",
    paymentFilter: true,
  };

  const displayEmpPaymentErrMsg = (errMsg) => {
    setErrSuccessMsg({
      message: errMsg,
      status: false,
    });
    // console.log("error pagination");
    setPaginationPaymentData({
      totalElements: 0,
      totalPages: 0,
    });
    setPaymentLoader(false);
  };

  const displayTimeLogErrErrMsg = (errMsg) => {
    setErrSuccessMsg({
      message: errMsg,
      status: false,
    });
  }

  const getPaymentData = async (endpoint, customerId) => {
    try {
      if(!isDownloadPaymentCSV && !isDownloadJobCSV){
        setPaymentLoader(true);
      }
      const api = `${endpoint}offset=0&page=${(isDownloadPaymentCSV || isDownloadJobCSV ) ? 0 : paymentCurrentPage - 1}&size=${(isDownloadPaymentCSV || isDownloadJobCSV ) ? paginationPaymentData?.totalElements : rowPaymentPerPage}&searchKey=${tableFilter?.searchKey}&sortBy=${tableFilter?.sortType}&sortDirection=${tableFilter?.sortDirection}`;
      const empPaymentResponse = await apiCall(api, "GET", null, TOKEN);
      console.log("empPaymentResponse---", empPaymentResponse);
  
      if (empPaymentResponse?.data?.content?.length > 0) {
        if (isDownloadPaymentCSV) {
         await handleDownloadPaymentCSV(empPaymentResponse?.data?.content);
        }else if(isDownloadJobCSV){
         await handleDownloadJobCSV(empPaymentResponse?.data?.content);
        } else {
          setEmpPaymentInfo(empPaymentResponse?.data?.content);
          setPaginationPaymentData({
            totalElements: empPaymentResponse?.data?.totalElements,
            totalPages: empPaymentResponse?.data?.totalPages,
          });
        }
        setPaymentLoader(false);
        // setSessionExpired(false);
      } else if (empPaymentResponse?.data.content?.length === 0) {
        setEmpPaymentInfo([]);
        setPaginationPaymentData({
          totalElements: 0,
          totalPages: 0,
        });
        setPaymentLoader(false);
      } else if (empPaymentResponse?.response?.status === 401) {
        // setSessionExpired(true);
        displayEmpPaymentErrMsg("Your session has expired!!");
      } else {
        // setSessionExpired(false);
        // displayEmpPaymentErrMsg("Something went wrong!");
        displayEmpPaymentErrMsg(empPaymentResponse?.response?.data?.message)
      }
    } catch (err) {
      console.log("Error payment details", err);
      // setSessionExpired(false);
    }finally{
      if(isDownloadPaymentCSV){
        setIsDownloadPaymentCSV(false);
      }else if(isDownloadJobCSV){
        setIsDownloadJobCSV(false);
      }
    }
  };

  const transferAmountApi = async (jobid) => {
    try {
      setLoadingButton(jobid);
      const api = `openstaff/reports/${jobid}/transferPayment`;
      const transferAmountResponse = await apiCall(api, "GET", null, TOKEN);
      console.log("transferAmountResponse---", transferAmountResponse);
  
      if (transferAmountResponse?.status === 200) {
        // setSessionExpired(false);
        setLoadingButton(null); 
        setErrSuccessMsg({
          message: "Payment transfer successfully!",
          status: true,
        });
        getEmpPaymentList();
      }else if (transferAmountResponse?.response?.status === 401) {
        // setSessionExpired(true);
        setLoadingButton(null); 
        setErrSuccessMsg({
          message: "Your session has expired!!",
          status: false,
        });
      } else {
        // setSessionExpired(false);
        setLoadingButton(null); 
        setErrSuccessMsg({
          message: transferAmountResponse?.response?.data?.message,
          status: false,
        });
      }
    } catch (err) {
      console.log("Error payment transfer error", err);
      // setSessionExpired(false);
      setLoadingButton(null); 
      setErrSuccessMsg({
        message: 'Network Error',
        status: false,
      });
    }
  };

 const getEmpPaymentList = () => {
  console.log("table filter=====", tableFilter)
  if (role_type?.includes("ROLE_INSTITUTION_ADMIN")) {
    if(activeTab === "report-payment-history"){
      getPaymentData(`institutions/${userInfo?.institutionId}/paymentDetails?status=${tableFilter?.jobStatus}&customerId=${userInfo?.institutionId}&profession=${tableFilter?.categoryType}&dateFilter=${tableFilter?.dateFilter}&startDate=${tableFilter?.startDate}&endDate=${tableFilter?.endDate}&`, userInfo?.institutionId);
    }else if(activeTab === "report-jobs"){
      getPaymentData(`institutions/${userInfo?.institutionId}/jobsDetail?status=${tableFilter?.jobStatus}&customerId=${userInfo?.institutionId}&profession=${tableFilter?.categoryType}&dateFilter=${tableFilter?.dateFilter}&startDate=${tableFilter?.startDate}&endDate=${tableFilter?.endDate}&`, userInfo?.institutionId);
    }
  } else if ((role_type?.includes("ROLE_OPENSTAFF_ADMIN") || role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN"))  && currentUrl?.includes('/reports')) {
    // getPaymentData('openstaff/institutions/institutionsPaymentDetails?')
    if(activeTab === "report-payment-history"){
      getPaymentData(`openstaff/jobs/paymentDetails?status=${tableFilter?.jobStatus}&company=${tableFilter?.companyName}&profession=${tableFilter?.categoryType}&dateFilter=${tableFilter?.dateFilter}&startDate=${tableFilter?.startDate}&endDate=${tableFilter?.endDate}&`);
    }else if(activeTab === "report-jobs"){
       getPaymentData(`openstaff/jobs/jobsDetail?status=${tableFilter?.jobStatus}&company=${tableFilter?.companyName}&profession=${tableFilter?.categoryType}&dateFilter=${tableFilter?.dateFilter}&startDate=${tableFilter?.startDate}&endDate=${tableFilter?.endDate}&`);
    };
  } else if ((role_type?.includes("ROLE_OPENSTAFF_ADMIN") || role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN")) && !currentUrl?.includes('/reports')) {
    // getPaymentData(`institutions/${customerDetail?.id}/paymentDetails?status=All&customerId=${customerDetail?.id}?`, customerDetail?.id);
    getPaymentData(`institutions/${customerDetail?.id}/paymentDetails?status=${tableFilter?.jobStatus}&customerId=${customerDetail?.id}&profession=${tableFilter?.categoryType}&dateFilter=${tableFilter?.dateFilter}&startDate=${tableFilter?.startDate}&endDate=${tableFilter?.endDate}&`, userInfo?.institutionId);
  }
};

  useEffect(() => {
    if (shouldFetch) {
      getEmpPaymentList();
    }
  }, [paymentCurrentPage,rowPaymentPerPage,tableFilter, shouldFetch]);

  useEffect(() => {
    setTableFilter({
      sortType: "createdDate",
      sortDirection: "desc",
      jobStatus: "",
      searchKey: "",
      categoryType: "",
      dateFilter:"",
      startDate: "",
      endDate: "",
      companyName: ""
    })
    setPaymentCurrentPage(1);
    setEmpPaymentInfo([]);
    setShouldFetch(true);
  }, [activeTab])

  useEffect(() =>{
    logEvent_Analytics('payment_details_screen_web');
  }, [])

  useEffect(() => {
    if(isDownloadPaymentCSV || isDownloadJobCSV){
      getEmpPaymentList()
    }
  }, [isDownloadPaymentCSV, isDownloadJobCSV])

  const handleRecordsPaymentPerPageChange = (event) => {
    setPaymentCurrentPage(1);
    setPaymentRowPerPage(event.target.value);
  };

  const handleSearchClick = (e) =>{
    if (e.key === "Enter") {
        setPaymentCurrentPage(1);
        setTableFilter({
            ...tableFilter,
            searchKey: searchKey
        })
    }
  }

  const handleSearchKeyFunction = () =>{
    setPaymentCurrentPage(1);
    setTableFilter({
        ...tableFilter,
        searchKey: searchKey
      })
  }

  const handleCompanyNameClick = (e) =>{
    if (e.key === "Enter") {
        setPaymentCurrentPage(1);
        setTableFilter({
            ...tableFilter,
            companyName: companyName
        })
    }
  }

  const handleCompanyNameFunction = () =>{
    setPaymentCurrentPage(1);
    setTableFilter({
        ...tableFilter,
        companyName: companyName
      })
  }

  useEffect(() => {
    loadScript("js/custom.js");
  });

  const navigateToJobDetail = (item) => {
    // dispatch(jobDetailsData({id : item}));
    navigate(`/job-detail/${item}`, { state: {id: item} });
  };

  const navigateToEmployee = (item) => {
    dispatch(employerDetails({ id: item }))
    navigate(`/comp-detail`, { state: {id: item} });
  };

  const getJobValue = (status, item) => {
    if (status === "eCompleted") {
      return <h5 style={{ fontWeight: "600", color: "green" }}>Completed</h5>; // Return an empty string or handle it as needed
    } else if (status === "eInProgress") {
      return <h5 style={{ fontWeight: "600", color: "orange" }}>InProgress</h5>;
    } else {
      return <h5 style={{ fontWeight: "600" }}>{status.startsWith("e") ? status.substring(1) : status}</h5>;
    }
  };

  const formatAddress = (address, city, state, zipCode) => {
    const parts = [address, city, state, zipCode].filter(Boolean);
    return parts.join(", ");
  };

  return (
    <>
      {currentUrl?.includes("/reports") && (
        <div>
          <Helmet>
            <title>{`Payment Information, Manage Payment Details, Payment Methods, Payment Overview | ${formatCompanyName()}`}</title>
            <meta
              name="description"
              content="Welcome to the Payment Details Page! Here, you can manage and update your payment information securely. This section allows you to add or modify your payment methods, view your transaction history, and manage billing preferences."
            />
            <meta name="keywords" content="payment details, payment methods " />
          </Helmet>
        </div>
      )}
      <div className="mt-5">
        <SectionRecordsFilter
          key={activeTab}
          _config={_filterConfig}
          rowPerPage={rowPaymentPerPage}
          handleRecordsPerPageChange={handleRecordsPaymentPerPageChange}
          setTableFilter={setTableFilter}
          tableFilter={tableFilter}
          setCurrentPage={setPaymentCurrentPage}
          handleSearchClick={handleSearchClick}
          handleSearchKeyFunction={handleSearchKeyFunction}
          handleCompanyNameClick={handleCompanyNameClick}
          handleCompanyNameFunction={handleCompanyNameFunction}
          setPaymentCurrentPage={setPaymentCurrentPage}
          setSearchKey={setSearchKey}
          searchKey={searchKey}
          companyName={companyName}
          setCompanyName={setCompanyName}
          currentPage={paymentCurrentPage}
          displayTimeLogErrErrMsg={displayTimeLogErrErrMsg}
          activeReportTabs={activeTab}
        />
        <div
          className="twm-right-section-panel candidate-save-job "
          style={{ padding: "0px" }}
        >
          <div className="twm-D_table table-responsive">
            <table
              id="payment-details-table"
              className="table table-bordered twm-candidate-save-job-list-wrap"
            >
              <thead>
                <tr>
                  <th>Job Title</th>
                  <th>Profession</th>
                  <th>Created Date</th>
                  <th>Job Status</th>
                  <th>Private</th>
                   {(role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
                    role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN")) && (
                    <th>Company</th>
                  )}
                  <th>Location</th>
                  <th>Client Name</th>
                  <th>Job Type</th>
                  <th>Schedule</th>
                  <th>Time Zone</th>
                  <th>Salary</th>
                  <th>Service Fee</th>
                  <th>Booking Fee</th>
                  <th>Total</th>
                  {(activeTab === "report-payment-history" || !currentUrl?.includes('/reports')) && (
                    <>
                      <th>Actual Total</th>
                      <th>Payment Method</th>
                      <th>Stripe Status</th>
                      <th>Payment ID</th>
                      <th>Payment Intent ID</th>
                      <th>Transfer ID</th>
                    </>
                  )}
                  <th>Workers</th>
                  <th>Worked Hours</th>
                  <th>Total Hours</th>
                  {(role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
                    role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN")) && (
                    <th>Action</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {/*1*/}
                {!paymentLoader ? (
                  empPaymentInfo?.length > 0 ? (
                    empPaymentInfo?.map((item) => (
                      <tr key={item?.id}>
                        <td style={{ minWidth: "200px", maxWidth: "200px" }}>
                          <div className="twm-candidate-save-job-list">
                            <div className="twm-mid-content">
                              {/* <h4>{item.jobTitle}</h4> */}
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() => navigateToJobDetail(item?.jobId)}
                                className="twm-job-title"
                              >
                                <h4>{item.jobTitle}</h4>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>{item?.jobPosition}</div>
                        </td>
                        <td>
                          <div>
                            {item?.modifiedDate
                              ? moment(item?.modifiedDate).format("MM/DD/YYYY")
                              : "-"}
                          </div>
                        </td>
                        <td>
                          <div>{getJobValue(item?.jobStatus, item)}</div>
                        </td>
                        <td>
                          <div>{item?.isPrivateJob ? "Yes" : "No"}</div>
                        </td>
                        {(role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
                          role_type?.includes(
                            "ROLE_OPENSTAFF_FINANCIAL_ADMIN"
                          )) &&
                          currentUrl?.includes("/reports") && (
                            <td style={{ maxWidth: "150", minWidth: "150" }}>
                              <NavLink
                                onClick={() =>
                                  navigateToEmployee(item?.instituteId)
                                }
                              >
                                {item?.name}
                              </NavLink>
                            </td>
                          )}
                        {(role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
                          role_type?.includes(
                            "ROLE_OPENSTAFF_FINANCIAL_ADMIN"
                          )) &&
                          currentUrl?.includes("/comp-detail") && (
                            <td style={{ maxWidth: "150", minWidth: "150" }}>
                              <NavLink>{customerDetail?.name}</NavLink>
                            </td>
                          )}
                        <td style={{ maxWidth: "220px", minWidth: "220px" }}>
                          {formatAddress(
                            item?.address,
                            item?.city,
                            item?.state,
                            item?.zipCode
                          )}
                        </td>
                        <td>
                          <div>{item?.clientName || "-"}</div>
                        </td>
                        <td>
                          <div>
                            {item?.multipleDayJob
                              ? "Multiple Day"
                              : "Single Day"}
                          </div>
                        </td>
                        <td style={{ maxWidth: "500px", minWidth: "450px" }}>
                          <div>
                            {item?.multipleDayJob ? (
                              item?.jobScheduleEntitiesDto?.length > 0 ? (
                                item?.jobScheduleEntitiesDto?.map(
                                  (itemm, index) => (
                                    <>
                                      <div>
                                        <b>Schedule {index + 1}</b>
                                      </div>
                                      {moment(
                                        itemm?.startDate,
                                        "YYYY-MM-DD HH:mm:ss"
                                      ).format("MM/DD/YYYY")}{" "}
                                      -{" "}
                                      {moment(
                                        itemm?.endDate,
                                        "YYYY-MM-DD HH:mm:ss"
                                      ).format("MM/DD/YYYY")}{" "}
                                      on {itemm?.sunday ? "Sun" : ""}{" "}
                                      {itemm?.monday ? "Mon" : ""}{" "}
                                      {itemm?.tuesday ? "Tue" : ""}{" "}
                                      {itemm?.wednesday ? "Wed" : ""}{" "}
                                      {itemm?.thursday ? "Thu" : ""}{" "}
                                      {itemm?.friday ? "Fri" : ""}{" "}
                                      {itemm?.saturday ? "Sat" : ""}
                                      <br />
                                      {moment
                                        .utc(
                                          itemm?.startTime,
                                          "YYYY-MM-DD HH:mm:ss"
                                        )
                                        .local()
                                        .format("hh:mm A")}{" "}
                                      -{" "}
                                      {moment
                                        .utc(
                                          itemm?.endTime,
                                          "YYYY-MM-DD HH:mm:ss"
                                        )
                                        .local()
                                        .format("hh:mm A")}{" "}
                                      for {itemm?.workHours} Hours
                                    </>
                                  )
                                )
                              ) : (
                                "No Schedule found"
                              )
                            ) : (
                              <>
                                {moment
                                  .utc(item?.startTime, "YYYY-MM-DD HH:mm:ss")
                                  .local()
                                  .format("MM/DD/YYYY")}
                                <br />
                                {moment
                                  .utc(item?.startTime, "YYYY-MM-DD HH:mm:ss")
                                  .local()
                                  .format("hh:mm A")}
                                -
                                {moment
                                  .utc(item?.endTime, "YYYY-MM-DD HH:mm:ss")
                                  .local()
                                  .format("hh:mm A")}
                              </>
                            )}
                          </div>
                        </td>
                        <td>
                          <div>{item?.timeZoneId}</div>
                        </td>
                        <td>
                          <div>
                            $
                            {item?.salary
                              ? (
                                  (item?.salary / 100) *
                                  Number(item?.totalHours) *
                                  Number(item?.noOfHires)
                                ).toFixed(2)
                              : 0.0}
                          </div>
                        </td>
                        <td>
                          <div>
                            $
                            {item?.serviceFee
                              ? (item?.serviceFee / 100).toFixed(2)
                              : 0.0}
                          </div>
                        </td>
                        <td>
                          <div>
                            $
                            {item?.bookingAndProcessingFee
                              ? (item?.bookingAndProcessingFee / 100).toFixed(2)
                              : 0.0}
                          </div>
                        </td>
                        <td>
                          <div>
                            $
                            {item?.amount
                              ? (item?.amount / 100).toFixed(2)
                              : 0.0}
                          </div>
                        </td>
                        {(activeTab === "report-payment-history" || !currentUrl?.includes('/reports')) && (
                          <>
                            <td>
                              <div>
                                $
                                {item?.totalWorkedAmount
                                  ? (item?.totalWorkedAmount / 100).toFixed(2)
                                  : 0.0}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item?.paymentMethod?.replace(
                                  /^"(.*)"$/,
                                  "$1"
                                ) || item?.paymentMethod}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item?.captured ? item.status : "uncaptured"}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item?.paymentId ? item?.paymentId : "-"}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item?.paymentIntentId
                                  ? item?.paymentIntentId
                                  : "-"}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item?.transferId ? item?.transferId : "-"}
                              </div>
                            </td>
                          </>
                        )}
                        <td style={{ maxWidth: "2000px", minWidth: "200px" }}>
                          <ul className="ps-2">
                            {item?.applicantsName?.length > 0
                              ? item.applicantsName.map((val) => {
                                  const { name, workerType } = val;
                                  const displayType =
                                    workerType === "Employee" || workerType === "Trusted Worker"
                                      ? ` (${workerType})`
                                      : "";

                                  return `${name}${displayType}`;
                                }).join(", ")
                              : "-"}
                          </ul>
                        </td>
                        <td>
                          <div>{item?.totalWorkedHours}</div>
                        </td>
                        <td>
                          <div>{item?.totalHours}</div>
                        </td>
                        {(role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
                          role_type?.includes(
                            "ROLE_OPENSTAFF_FINANCIAL_ADMIN"
                          )) &&
                        item?.jobStatus === "eCompleted" &&
                        item?.paymentMethod === "stripe" ? (
                          <td>
                            <button
                              className="site-button"
                              disabled={loadingButton}
                              onClick={() => transferAmountApi(item.jobId)}
                            >
                              {loadingButton === item.jobId ? (
                                <Spinner size="sm" />
                              ) : (
                                "Transfer"
                              )}
                            </button>
                          </td>
                        ) : (
                          role_type?.includes("ROLE_OPENSTAFF_ADMIN") && (
                            <td></td>
                          )
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={25} style={{ textAlign: "center" }}>
                        No results found.
                      </td>
                    </tr>
                  )
                ) : (
                  <tr>
                    <td colSpan={25} style={{ textAlign: "center" }}>
                      <TableLoader />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <SectionPagination
            currentPage={paymentCurrentPage}
            setCurrentPage={setPaymentCurrentPage}
            totalPages={paginationPaymentData?.totalPages}
          />
        </div>

        {errSuccessMesg?.message != "" ? (
          <Toast message={errSuccessMesg} />
        ) : (
          ""
        )}

        <JobViewPopup />
      </div>
    </>
  );
}

export default CanPaymentDetailsPage;
